<div class="container-fluid mt-4">
    <div class="row">


        <div class="col-lg-12 d-flex justify-content-between align-items-center">

            <div class="col-md-2 mb-2">


            </div>
            <div class="col-10 mb-2 text-end">
                <button (click)="back()" class="btn btn-secondary" style="font-size: large;">
                    Back
                </button> &nbsp;
                <button class="btn btn-primary" (click)="previewAudit()" style="font-size: large;">
                    Preview
                </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4">
            <div class="card">
                <div class="card-header d-flex align-items-center justify-content-between gap-1">
                    <h5 class="election-title">Checklist</h5>


                    <div class="d-flex align-items-center justify-content-between gap-1">
                        <button type="button" class="btn btn-success btn-sm" data-bs-toggle="modal"
                            data-bs-target="#ChecklistStatusReport"
                            [style.display]="roleid == 9 ? 'none' : 'inline-block'">
                            <i class="bi bi-list-check me-1">
                            </i> Remark & Process
                        </button>


                        <button type="button" title="Audit Status & History"
                            class="btn btn-info btn-sm justify-content-between gap-1"
                            (click)="auditStatusProcess(trans?.iSocietyDetailsId,trans?.iAllotAuditorID)"
                            data-bs-toggle="modal" data-bs-target="#AuditorStatus">
                            <i class="bi bi-clock-history"></i> Audit Status
                        </button>

                        <!-- <button type="button" class="btn btn-success btn-sm" 
                       (click)="ViewStatusModal()" >
                        <i class="bi bi-list-check me-1">
                        </i> Status
                    </button> -->
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="checklist-status" data-bs-backdrop="static" data-bs-keyboard="false"
                        tabindex="-1" aria-labelledby="checklist-statusLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5" id="checklist-statusLabel">Status</h1>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                                        aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="step-progressbar">
                                        <div class="v-progress">
                                            <ul>
                                                <li *ngFor="let process of lstAuditProcess"
                                                    class="{{ process.status }}">
                                                    {{ process.statusname }} <br>
                                                    <small style="font-size: 12px;">{{ process.dCreateDate |
                                                        date:'dd/MM/yyyy' }}</small>

                                                </li>
                                            </ul>

                                        </div>


                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary"
                                        data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="">


                    <div class="card-body">

                        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                            aria-orientation="vertical">
                            <button class="nav-link text-start active" id="v-pills-SocietyInformation-tab"
                                data-bs-toggle="pill" data-bs-target="#v-pills-SocietyInformation" type="button"
                                role="tab" aria-controls="v-pills-SocietyInformation" aria-selected="true"> Society
                                Information</button>
                            <button class="nav-link text-start" id="v-pills-MembersEmployeeDetails-tab"
                                data-bs-toggle="pill" data-bs-target="#v-pills-MembersEmployeeDetails" type="button"
                                role="tab" aria-controls="v-pills-MembersEmployeeDetails" aria-selected="false">
                                Members and
                                Employee
                                Details</button>
                            <button class="nav-link text-start" id="v-pills-SocietyServices-tab" data-bs-toggle="pill"
                                data-bs-target="#v-pills-SocietyServices" type="button" role="tab"
                                aria-controls="v-pills-SocietyServices" aria-selected="false"> Society Services</button>
                            <button class="nav-link text-start" id="v-pills-AuditDetails-tab" data-bs-toggle="pill"
                                data-bs-target="#v-pills-AuditDetails" type="button" role="tab"
                                aria-controls="v-pills-AuditDetails" aria-selected="false"> Audit Details</button>
                            <button class="nav-link text-start" id="v-pills-BalanceSheet-tab" data-bs-toggle="pill"
                                data-bs-target="#v-pills-BalanceSheet" type="button" role="tab"
                                aria-controls="v-pills-BalanceSheet" aria-selected="false"> Balance Sheet</button>
                            <button class="nav-link text-start" id="v-pills-OtherDetails-tab" data-bs-toggle="pill"
                                data-bs-target="#v-pills-OtherDetails" type="button" role="tab"
                                aria-controls="v-pills-OtherDetails" aria-selected="false"> Other Details</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-8">
            <div class="tab-content" id="SocietyChecklist">
                <div class="tab-pane fade show active" id="v-pills-SocietyInformation" role="tabpanel"
                    aria-labelledby="v-pills-SocietyInformation-tab" tabindex="0">

                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">🗂️ Society Information</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Society Name</strong></label>
                                                    <p class="m-0">{{ trans?.sSocietyName }}</p>

                                                </div>
                                                <!-- Address -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Address</strong></label>
                                                    <p class="m-0">
                                                        {{ trans?.address }}
                                                    </p>
                                                </div>

                                                <!-- Registration Date -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Registration
                                                            Date</strong></label>
                                                    <p class="m-0">{{
                                                        formatDateToYYYYMMDD(trans?.dFinishApplicationdate) }}
                                                    </p>
                                                </div>

                                                <!-- Registration No. -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Registration
                                                            No.</strong></label>
                                                    <p class="m-0">{{ trans?.sSocietyRegistrationNo }}</p>
                                                </div>

                                                <!-- Society Category -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Society
                                                            Category</strong></label>
                                                    <p class="m-0">{{ trans?.categoryName }}</p>
                                                </div>

                                                <!-- Society Type -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Society Type</strong></label>
                                                    <p class="m-0">{{ trans?.type }}</p>
                                                </div>
                                                <!-- Society Kind -->
                                                <div class="col-lg-6 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Society Kind</strong></label>
                                                    <p class="m-0">
                                                        {{ trans?.iSKindid == 3 ? 'Credit' : trans?.iSKindid == 4 ?
                                                        'Non-Credit' :
                                                        '-'
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="card">

                                        <div class="card-header" style="border-left:0px;">
                                            <h5 class="election-title">Society Status</h5>
                                        </div>

                                        <div class="card-body">
                                            <div class="row">

                                                <!-- Audit Year -->
                                                <div class="col-lg-6 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Audit Society
                                                            Status</strong></label>
                                                    <p class="m-0">{{ trans?.statusSocieties }}</p>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="card">

                                        <div class="card-header" style="border-left:0px;">
                                            <h5 class="election-title">Society Building Details</h5>
                                        </div>

                                        <div class="card-body">
                                            <div class="row">


                                                <!-- Society Building -->
                                                <div class="col-lg-6 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Society
                                                            Building</strong></label>
                                                    <p class="m-0">
                                                        {{ trans?.iSocietyBuilding === true ? 'Yes' :
                                                        (trans?.iSocietyBuilding ===
                                                        false
                                                        ? 'No' : '') }}
                                                    </p>
                                                </div>

                                                <!-- Building Type -->
                                                <div class="col-lg-6 col-md-6 mb-2"
                                                    *ngIf=" trans?.iSocietyBuilding === true">
                                                    <label class="form-label m-0"><strong>Building Type</strong></label>
                                                    <p class="m-0">
                                                        <ng-container *ngIf="trans?.buildingType; else noData">
                                                            {{ trans.buildingType }}
                                                        </ng-container>
                                                        <ng-template #noData>
                                                            <span class="text-danger">NA</span>
                                                        </ng-template>
                                                    </p>
                                                </div>

                                                <!-- Building Remarks -->
                                                <div class="col-lg-12 mb-2" *ngIf=" trans?.iSocietyBuilding === true">
                                                    <label class="form-label m-0"><strong>Remarks</strong></label>

                                                    <p class="m-0">
                                                        <ng-container *ngIf="trans?.buildingRemarks; else noData">
                                                            {{ trans.buildingRemarks }}
                                                        </ng-container>
                                                        <ng-template #noData>
                                                            <span class="text-danger">NA</span>
                                                        </ng-template>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="card">

                                        <div class="card-header" style="border-left:0px;">
                                            <h5 class="election-title">Society Land Details</h5>
                                        </div>

                                        <div class="card-body">
                                            <div class="row">

                                                <!-- Land Details -->
                                                <div class="col-lg-3 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Land Details</strong></label>
                                                    <p class="m-0">
                                                        {{ trans?.iLandDetailType === true ? 'Yes' :
                                                        (trans?.iLandDetailType
                                                        ===
                                                        false
                                                        ? 'No' : '') }}</p>
                                                </div>

                                                <!-- Type of Possession -->
                                                <div class="col-lg-3 col-md-6 mb-2"
                                                    *ngIf=" trans?.iLandDetailType === true">
                                                    <label class="form-label m-0"><strong>Type of
                                                            Possession</strong></label>

                                                    <p class="m-0">
                                                        <ng-container *ngIf="trans?.possessionType; else noData">
                                                            {{ trans.possessionType }}
                                                        </ng-container>
                                                        <ng-template #noData>
                                                            <span class="text-danger">NA</span>
                                                        </ng-template>
                                                    </p>
                                                </div>

                                                <!-- Area -->
                                                <div class="col-lg-3 col-md-6 mb-2"
                                                    *ngIf=" trans?.iLandDetailType === true">
                                                    <label class="form-label m-0"><strong>Area</strong></label>

                                                    <p class="m-0">
                                                        <ng-container *ngIf="trans?.landArea; else noData">
                                                            {{ trans.landArea }}
                                                        </ng-container>
                                                        <ng-template #noData>
                                                            <span class="text-danger">NA</span>
                                                        </ng-template>
                                                    </p>
                                                </div>

                                                <!-- Land Remarks -->
                                                <div class="col-lg-3 col-md-6 mb-2"
                                                    *ngIf=" trans?.iLandDetailType === true">
                                                    <label class="form-label m-0"><strong>Remarks</strong></label>

                                                    <p class="m-0">
                                                        <ng-container *ngIf="trans?.landRemark; else noData">
                                                            {{ trans.landRemark }}
                                                        </ng-container>
                                                        <ng-template #noData>
                                                            <span class="text-danger">NA</span>
                                                        </ng-template>
                                                    </p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>




                </div>

                <div class="tab-pane fade" id="v-pills-MembersEmployeeDetails" role="tabpanel"
                    aria-labelledby="v-pills-MembersEmployeeDetails-tab" tabindex="0">

                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">🧑‍🏫 Members and Employee Details</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <div class="col-lg-12">
                                    <div class="card">

                                        <div class="card-body">
                                            <div class="row">



                                                <!-- General Member Fields -->
                                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="trans?.iSCategoryid != 1">
                                                    <label class="form-label m-0"><strong>Total Society Members
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.totalMember }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="trans?.iSCategoryid != 1">
                                                    <label class="form-label m-0"><strong>Cooperative Societies
                                                            No</strong>
                                                    </label>
                                                    <p class="m-0">{{ auditMember?.coOperativeSocietyNo }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Total Individuals
                                                            Number</strong></label>
                                                    <p class="m-0">{{ auditMember?.totalIndividualNo }}</p>

                                                </div>

                                                <!-- Gender Fields -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Male Member No</strong>
                                                    </label>
                                                    <p class="m-0">{{ auditMember?.maleMember }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Female Member No
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.femaleMember }}</p>

                                                </div>

                                                <!-- Caste Category Fields -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>General Member
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.generalMemberNo }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>OBC Member No</strong></label>
                                                    <p class="m-0">{{ auditMember?.obcMemberNo }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>SC Member No</strong></label>
                                                    <p class="m-0">{{ auditMember?.scMemberNo }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>ST Member No</strong></label>
                                                    <p class="m-0">{{ auditMember?.stMemberNo }}</p>


                                                </div>
                                                <!-- <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Trained Member
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.generaltrainedEmployees }}</p>

                                                </div>
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Non-Trained Member
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.generalnonTrainedEmployees }}</p>

                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-header" style="border-left:0px;">
                                            <h5 class="election-title">Management Committee Details</h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">



                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Total Committee Members
                                                            No</strong> </label>
                                                    <p class="m-0">{{ auditMember?.totalNoCommittee }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Total Person on Positions
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.totalPersonOnPositons }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Vacant Positions
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.vacantPositions }}</p>

                                                </div>
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Trained Member
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.trainedmember }}</p>

                                                </div>
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Non-Trained Member
                                                            No</strong></label>
                                                    <p class="m-0">{{ auditMember?.nonTrainedmember }}</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-header" style="border-left:0px;">
                                            <h5 class="election-title">Employee Details</h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <!-- Employee Section -->


                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Total Employees No</strong>
                                                    </label>
                                                    <p class="m-0">{{ auditMember?.totalNumberOfEmployess }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Trained Employees No
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.trainedEmployees }}</p>

                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Non-Trained Employees No
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.nonTrainedEmployees }}</p>

                                                </div>
                                                <hr>
                                                <!-- <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label m-0"><strong>Secretary Type
                                                        </strong></label>
                                                    <p class="m-0">{{ auditMember?.sectarytype }}</p>

                                                </div> -->


                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div class="tab-pane fade" id="v-pills-SocietyServices" role="tabpanel"
                    aria-labelledby="v-pills-SocietyServices-tab" tabindex="0">

                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">🧰 Society Services</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card">

                                        <div class="card-body">
                                            <div class="row">

                                                <!-- GST NO -->
                                                <div class="col-6 mb-2">
                                                    <label class="form-label m-0"><strong>GST No</strong></label>
                                                    <p class="m-0">{{ service?.gstNo || '-'}}</p>


                                                </div>

                                                <!-- PAN NO -->
                                                <div class="col-6 mb-2">
                                                    <label class="form-label m-0"><strong>PAN No</strong></label>
                                                    <p class="m-0">{{ service?.panNo || '-'}}</p>


                                                </div>

                                                <!-- TAN NO -->
                                                <div class="col-6 mb-2">
                                                    <label class="form-label m-0"><strong>TAN No</strong></label>
                                                    <p class="m-0">{{ service?.tanNo || '-'}}</p>


                                                </div>

                                                <!-- EPF NO -->
                                                <div class="col-6 mb-2">
                                                    <label class="form-label m-0"><strong>EPF No</strong></label>
                                                    <p class="m-0">{{ service?.epfNo || '-' }}</p>


                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <ng-container *ngFor="let ser of lstBussinessUpgrades">
                                        <ng-container *ngIf="ser.checkd">
                                            <div class="card">
                                                <div class="card-header" style="border-left:0px;">
                                                    <h5 class="election-title">{{ ser.name }}</h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="row">
                                                        <ng-container
                                                            *ngIf="ser.groupedSubFields && ser.groupedSubFields.length > 0">
                                                            <ng-container *ngFor="let group of ser.groupedSubFields">
                                                                <div class="col-12 my-2" *ngIf="group.heading">
                                                                    <h6 class="text-secondary fw-bold">{{ group.heading
                                                                        }}</h6>
                                                                </div>

                                                                <ng-container
                                                                    *ngIf="group.fields && group.fields.length > 0; else handleGroupWithoutFields">
                                                                    <div class="row">
                                                                        <div class="col-md-6 mb-3"
                                                                            *ngFor="let subSer of group.fields">
                                                                            <label class="form-label">
                                                                                {{ subSer.labelName }}

                                                                            </label>

                                                                            <p class="form-control-static">
                                                                                <ng-container
                                                                                    [ngSwitch]="subSer.inputType?.toLowerCase()">
                                                                                    <ng-container
                                                                                        *ngSwitchCase="'dropdown'">
                                                                                        {{ subSer.value?.length ?
                                                                                        subSer.value.join(', ') : '-' }}
                                                                                    </ng-container>
                                                                                    <ng-container
                                                                                        *ngSwitchCase="'boolean'">
                                                                                        {{ subSer.value === true ? 'Yes'
                                                                                        : (subSer.value === false ? 'No'
                                                                                        : '-') }}
                                                                                    </ng-container>
                                                                                    <ng-container *ngSwitchDefault>
                                                                                        {{ subSer.value != null &&
                                                                                        subSer.value !== '' ?
                                                                                        subSer.value : '-' }}
                                                                                    </ng-container>
                                                                                </ng-container>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </ng-container>

                                                                <ng-template #handleGroupWithoutFields>
                                                                    <div class="col-md-6 mb-3">
                                                                        <label class="form-label">
                                                                            {{ group.labelName }}

                                                                        </label>

                                                                        <p class="form-control-static">
                                                                            <ng-container
                                                                                [ngSwitch]="group.inputType?.toLowerCase()">
                                                                                <ng-container
                                                                                    *ngSwitchCase="'dropdown'">
                                                                                    {{ group.value?.length ?
                                                                                    group.value.join(', ') : '-' }}
                                                                                </ng-container>
                                                                                <ng-container *ngSwitchCase="'boolean'">
                                                                                    {{ group.value === true ? 'Yes' :
                                                                                    (group.value === false ? 'No' : '-')
                                                                                    }}
                                                                                </ng-container>
                                                                                <ng-container *ngSwitchDefault>
                                                                                    {{ group.value != null &&
                                                                                    group.value !== '' ? group.value :
                                                                                    '-' }}
                                                                                </ng-container>
                                                                            </ng-container>
                                                                        </p>
                                                                    </div>

                                                                    <!-- Conditional Fields for Boolean TRUE -->
                                                                    <div *ngIf="group.inputType?.toLowerCase() === 'boolean' && group.value === true && group.groupedConditionalFields?.length"
                                                                        class="row mt-3">
                                                                        <div class="col-12"
                                                                            *ngFor="let groupItem of group.groupedConditionalFields">
                                                                            <div *ngIf="groupItem.heading && groupItem.heading !== 'General'"
                                                                                class="mb-2">
                                                                                <h6
                                                                                    class="fw-bold text-decoration-underline">
                                                                                    {{ groupItem.heading }}</h6>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-6 mb-3"
                                                                                    *ngFor="let cond of groupItem.fields">
                                                                                    <label class="form-label">
                                                                                        {{ cond.labelName }}

                                                                                    </label>
                                                                                    <p class="form-control-static">
                                                                                        <ng-container
                                                                                            [ngSwitch]="cond.inputType?.toLowerCase()">
                                                                                            <ng-container
                                                                                                *ngSwitchCase="'dropdown'">
                                                                                                {{ cond.value?.length ?
                                                                                                cond.value.join(', ') :
                                                                                                '-' }}
                                                                                            </ng-container>
                                                                                            <ng-container
                                                                                                *ngSwitchCase="'boolean'">
                                                                                                {{ cond.value === true ?
                                                                                                'Yes' : (cond.value ===
                                                                                                false ? 'No' : '-') }}
                                                                                            </ng-container>
                                                                                            <ng-container
                                                                                                *ngSwitchDefault>
                                                                                                {{ cond.value != null &&
                                                                                                cond.value !== '' ?
                                                                                                cond.value : '-' }}
                                                                                            </ng-container>
                                                                                        </ng-container>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>


                            </div>
                        </div>
                    </div>


                </div>


                <div class="tab-pane fade" id="v-pills-AuditDetails" role="tabpanel"
                    aria-labelledby="v-pills-AuditDetails-tab" tabindex="0">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">📊 Audit Details</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <!-- Audit Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Audit Year</strong> </label>
                                    <p class="m-0">{{ trans?.sAuditYear }}</p>

                                </div>

                                <!-- Auditor Name -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0">
                                        <strong> Auditor Name</strong>
                                    </label>

                                    <p class="m-0">{{ allotData?.fullName }}</p>
                                </div>

                                <!-- Audit Allotment Date -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0">
                                        <strong>Audit Allotment Date </strong>
                                    </label>
                                    <p class="m-0">{{ allotData?.auditAllotDate }}</p>
                                </div>


                                <!-- Working Capital -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"> <strong>Working Capital</strong></label>
                                    <p class="m-0">{{ trans?.workingCapital }}</p>

                                </div>

                                <!-- Audit Classification (in Lakhs) -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"> <strong>Audit Classification<sup> (in
                                                Lakhs)</sup></strong>
                                    </label>
                                    <p class="m-0">{{ trans?.auditClassification }}</p>

                                </div>

                                <!-- Audit Start Date -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"> <strong>Audit Start Date</strong></label>
                                    <p class="m-0">
                                        {{formatDateToYYYYMMDD(trans?.auditStartDate) }}
                                    </p>

                                </div>

                                <!-- Submission Date -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"> <strong>Submission Date</strong> </label>
                                    <p class="m-0">{{ formatDateToYYYYMMDD(trans?.submissionDate) }}</p>

                                </div>

                                <!-- General House Meeting Date -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"> <strong>Last General House Meeting Date</strong>
                                    </label>
                                    <p class="m-0">{{ formatDateToYYYYMMDD(trans?.ghmDate)}}</p>

                                </div>



                            </div>

                        </div>
                    </div>
                </div>


                <div class="tab-pane fade" id="v-pills-BalanceSheet" role="tabpanel"
                    aria-labelledby="v-pills-BalanceSheet-tab" tabindex="0">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">📈 Balance Sheet</h5>
                        </div>
                        <div class="card-body">

                            <div class="row">



                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label"> <strong>As On Date</strong></label>
                                    <p class="m-0">{{ asOnDate | date: 'dd-MM-yyyy'}}</p>
                                </div>
                                <div class="row mt-2" *ngIf="UploadbalanceList || sUploadRD || sUploadpnL">

                                    <div class="d-flex flex-wrap gap-6 align-items-end">

                                        <a *ngIf="UploadbalanceList" class="btn btn-success btn-sm"
                                            style="cursor:pointer" (click)="downloadFile(UploadbalanceList)">
                                            <i class="fa fa-download me-1"></i> BalanceSheet Download
                                        </a>

                                        <a *ngIf="sUploadRD" class="btn btn-success btn-sm" style="cursor:pointer"
                                            (click)="downloadFile(sUploadRD)">
                                            <i class="fa fa-download me-1"></i>
                                            Download RD
                                        </a>

                                        <a *ngIf="sUploadpnL" class="btn btn-success btn-sm" style="cursor:pointer"
                                            (click)="downloadFile(sUploadpnL)">
                                            <i class="fa fa-download me-1"></i>
                                            Download PnL
                                        </a>


                                    </div>
                                </div>

                                <div class="row">
                                    <!-- Liabilities Table -->
                                    <div class="col-lg-12 mt-3">
                                        <h5 class="election-title">Liabilities</h5>
                                        <ngx-datatable
                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                            [rows]="liabilityData" [columns]="column" [columnMode]="'force'"
                                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                            [count]="liabilityData.length" [limit]="10" [scrollbarV]="false"
                                            [scrollbarH]="true" [loadingIndicator]="loading">
                                            <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                                                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                                                    <span>{{ rowIndex + 1 }}</span>
                                                </ng-template>
                                            </ngx-datatable-column>

                                            <ngx-datatable-column *ngFor="let col of column" [name]="col.name"
                                                [prop]="col.prop" [sortable]="true">
                                                <ng-template let-value="value" ngx-datatable-cell-template>
                                                    {{ value }}
                                                </ng-template>
                                            </ngx-datatable-column>
                                        </ngx-datatable>
                                        <!-- Liabilities Total -->
                                        <div class="text-end mt-2">
                                            <h5><strong>Total (Liabilities): ₹ {{ totalLiability | number: '1.2-2'
                                                    }}</strong></h5>
                                        </div>
                                    </div>

                                    <!-- Assets Table -->
                                    <div class="col-lg-12 mt-3">
                                        <h5 class="election-title">Assets</h5>
                                        <ngx-datatable
                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                            [rows]="assetData" [columns]="column" [columnMode]="'force'"
                                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                            [count]="assetData.length" [limit]="10" [scrollbarV]="false"
                                            [scrollbarH]="true" [loadingIndicator]="loading">
                                            <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                                                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                                                    <span>{{ rowIndex + 1 }}</span>
                                                </ng-template>
                                            </ngx-datatable-column>

                                            <ngx-datatable-column *ngFor="let col of column" [name]="col.name"
                                                [prop]="col.prop" [sortable]="true">
                                                <ng-template let-value="value" ngx-datatable-cell-template>
                                                    {{ value }}
                                                </ng-template>
                                            </ngx-datatable-column>
                                        </ngx-datatable>
                                        <!-- Assets Total -->
                                        <div class="text-end mt-2">
                                            <h5><strong>Total (Assets): ₹ {{ totalAsset | number: '1.2-2' }}</strong>
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-3 text-end border-top pt-2">
                                        <h5><strong>Total (Liabilities + Assets): ₹ {{ totalLiability + totalAsset |
                                                number:
                                                '1.2-2' }}</strong>
                                        </h5>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="v-pills-OtherDetails" role="tabpanel"
                    aria-labelledby="v-pills-OtherDetails-tab" tabindex="0">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="election-title">📋 Other Details</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">

                                <!-- Income -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Turnover</strong></label>
                                    <p class="m-0">{{ otherParams?.income }}</p>

                                </div>

                                <!-- Expenditure -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Total Expense</strong></label>
                                    <p class="m-0">{{ otherParams?.expenditure }}</p>

                                </div>

                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.profit">
                                    <label class="form-label m-0"><strong>Total Net Profit</strong></label>
                                    <p class="m-0">{{ otherParams?.profit }}</p>

                                </div>

                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.loss">
                                    <label class="form-label m--0"><strong>Total Net Loss</strong></label>
                                    <p class="m-0">{{ otherParams?.loss }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Audit Fees</strong></label>
                                    <p class="m-0">{{ otherParams?.auditFees }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Do you Have Branches</strong>
                                    </label>

                                    <p class="m-0">
                                        {{ otherParams?.branches === true ? 'Yes' :
                                        (otherParams?.branches === false ? 'No' : '') }}
                                    </p>


                                </div>


                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                    <label class="form-label m-0"><strong>No. of Branches</strong></label>
                                    <p class="m-0">{{ otherParams?.noOfBranches }}</p>

                                </div>


                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                    <label class="form-label m-0"><strong>Branches Fees</strong></label>
                                    <p class="m-0">{{ otherParams?.bauditFees }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                    <label class="form-label m-0"><strong>Total Audit Fee </strong></label>
                                    <p class="m-0">{{ otherParams?.auditTFees }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Govt. Guarantee</strong>
                                    </label>

                                    <p class="m-0">
                                        {{ otherParams?.guarantee === true ? 'Yes' :
                                        (otherParams?.guarantee === false ? 'No' : '') }}
                                    </p>


                                </div>
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.guarantee === true">
                                    <label class="form-label m-0"><strong>Total Amount </strong></label>
                                    <p class="m-0">{{ otherParams?.totalamount }}</p>

                                </div>



                                <!-- Govt Share -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Share</strong></label>
                                    <p class="m-0">{{ otherParams?.govtShare }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Share Principal </strong> </label>
                                    <p class="m-0">{{ otherParams?.govtLoanPrincipal }}</p>

                                </div>

                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Share Interest</strong> </label>
                                    <p class="m-0">{{ otherParams?.govtLoanInterest }}</p>

                                </div>


                                <!-- Redemption of Govt. Share -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Redemption of Govt. Share</strong></label>
                                    <p class="m-0">{{ otherParams?.redemptionOfGovtShare }}</p>

                                </div>

                                <!-- Govt. Dividend Payable -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Dividend Payable</strong> </label>
                                    <p class="m-0">{{ otherParams?.govtDividentPayable }}</p>

                                </div>


                                <!-- Govt. Dividend Paid -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Dividend Paid</strong></label>
                                    <p class="m-0">{{ otherParams?.govtDividentPaid }}</p>

                                </div>

                                <!-- Govt. Loan -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Govt. Loan</strong></label>
                                    <p class="m-0">{{ otherParams?.govtLoan }}</p>

                                </div>

                                <!-- Recovery of Principal -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Recovery of Principal</strong></label>
                                    <p class="m-0">{{ otherParams?.recoveryOfPrincipal }}</p>

                                </div>

                                <!-- Recovery of Interest -->
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                    <label class="form-label m-0"><strong>Recovery of Interest</strong> </label>
                                    <p class="m-0">{{ otherParams?.recoveryOfInterest }}</p>

                                </div>

                                <!-- Misappropriation -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label m-0"><strong>Misappropriation/Embezzlement</strong>
                                    </label>

                                    <p class="m-0">
                                        {{ otherParams?.misappropriationEmbezzlement === true ? 'Yes' :
                                        (otherParams?.misappropriationEmbezzlement === false ? 'No' : '') }}
                                    </p>


                                </div>

                                <!-- Date of Detection -->
                                <div class="col-lg-4 col-md-6 mb-2"
                                    *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                    <label class="form-label m-0"><strong>Date of Detection</strong> </label>
                                    <p class="m-0">{{ otherParams?.dateOfDetection | date: 'dd/MM/yyyy' }}</p>



                                </div>

                                <!-- Amount Involved -->
                                <div class="col-lg-4 col-md-6 mb-2"
                                    *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                    <label class="form-label m-0"><strong>Amount Involved</strong></label>
                                    <p class="m-0">{{ otherParams?.amountInvolved }}</p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2"
                                    *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                    <label class="form-label m-0"><strong>Total Amount Recovered</strong></label>
                                    <p class="m-0">{{ otherParams?.amountRecoverd }}</p>

                                </div>

                                <!-- Special Report -->
                                <div class="col-lg-4 col-md-6 mb-2"
                                    *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                    <label for="specialReport" class="form-label m-0"><strong>Special Report</strong>
                                    </label>

                                    <p class="m-0">
                                        {{ otherParams?.specialReport === true ? 'Yes' : (otherParams?.specialReport
                                        ===
                                        false ? 'No' : '') }}
                                    </p>

                                </div>
                                <div class="col-lg-4 col-md-6 mb-2"
                                    *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                    <label class="form-label m-0"><strong>Remark</strong></label>
                                    <p class="m-0">{{ otherParams?.remark }}</p>

                                </div>


                            </div>


                            <!-- Modal Start-->
                            <div class="modal fade" id="checklistStatus" data-bs-backdrop="static"
                                data-bs-keyboard="false" tabindex="-1" aria-labelledby="checklistStatusLabel"
                                aria-hidden="true">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h1 class="modal-title fs-5" id="checklistStatusLabel">Status</h1>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-lg-6 mb-2">
                                                    <label class="form-label">Status</label>



                                                </div>

                                                <div class="col-lg-6 mb-2">
                                                    <label class="form-label" for="checklistStatusFile">Report
                                                        Upload</label>

                                                </div>

                                                <div class="col-lg-12 mb-2">
                                                    <label class="form-label">Remarks</label>

                                                </div>
                                                <div class="col-lg-12 mb-2">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            id="DisclaimerAudit"
                                                            style="transform: scale(1.2); accent-color: black; font-weight: bold;">
                                                        <label class="form-check-label" for="DisclaimerAudit">
                                                            <strong>Disclaimer:</strong> Before marking the report
                                                            as
                                                            prepared, read this
                                                            carefully and check
                                                            the box if you agree. If you tick the disclaimer, it
                                                            means
                                                            you have checked all
                                                            the records carefully.
                                                        </label>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary"
                                                data-bs-dismiss="modal">Close</button>
                                            <button type="button" class="btn btn-primary">Submit</button>
                                        </div>
                                    </div>

                                </div>
                                <!-- Modal End-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="ChecklistStatusReport" data-bs-backdrop="static" data-bs-keyboard="false"
                tabindex="-1" aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                    <div class="modal-content">

                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h1 class="modal-title election-title" id="ChecklistStatusReportLabel">Status</h1>

                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            </button>
                        </div>
                        <!-- Modal Body -->
                        <div class="modal-body">
                            <form #deptRemarkForm="ngForm" (ngSubmit)="onSubmitRemark(deptRemarkForm)">

                                <!-- Role Selection -->
                                <div class="row mb-3">
                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Select Role</label>
                                        <select class="form-control" (change)="onChangeRole()" name="selectedViewRole"
                                            [(ngModel)]="selectedViewRole" required>
                                            <option [value]="0" disabled>Select Role</option>

                                            <option *ngFor="let role of roleFilterList" [value]="role.id">
                                                {{ role.name }}
                                            </option>

                                        </select>
                                    </div>

                                    <!-- Status Dropdown -->
                                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="isShowupdateButton">
                                        <label class="form-label">Select Status <span
                                                class="text-danger">*</span></label>
                                        <select class="form-control" [(ngModel)]="ddlStatus" name="ddlStatus" required>
                                            <option value="" disabled>Select Status</option>

                                            <option value="MoveForwardToAR"
                                                *ngIf="selectedViewRole == 2 && roleid != 13">
                                                Move Forward</option>
                                            <option value="InSendBack"
                                                *ngIf="selectedViewRole == 2 && !trans?.isSendBack && !trans?.isLiquidatorRequest">
                                                Send Back</option>

                                            <option value="MoveForwardAudit" *ngIf="roleid === 13 && statusid == 7">Move
                                                Forward
                                            </option>

                                            <option value="SendBackAudit"
                                                *ngIf="(roleid === 13 && statusid == 5) || (roleid === 13 && statusid == 7 && trans?.isSendBack)">
                                                Send Back</option>
                                            <option value="MoveForwardToARApproved"
                                                *ngIf="selectedViewRole == 3 && statusid == 3">Approved</option>
                                        </select>
                                    </div>

                                    <div class="col-lg-4 col-md-6 mb-2"
                                        *ngIf="isShowArRemark && !isShowVerRemark && isShowupdateButton">

                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <label class="form-label">
                                                Upload File
                                            </label>

                                            <a *ngIf="arUpload" href="javascript:void(0)"
                                                class="text-decoration-none text-primary small fw-semibold d-inline-flex align-items-center"
                                                (click)="previewFile(arUpload,'IdentityDetails')">
                                                <i>View</i>
                                            </a>
                                        </div>
                                        <input class="form-control" type="file" id="arUploadFile"
                                            (change)="onFileChange2($event)" name="document"
                                            [(ngModel)]="ARnewUpload.DepartmentalRemarkDocument">
                                        <small class="form-text text-muted">
                                            type: pdf | Max size: 2 MB
                                        </small>

                                    </div>
                                    <div class="col-lg-4 col-md-6 mb-2"
                                        *ngIf="isShowVerRemark && !isShowArRemark && isShowupdateButton">

                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <label class="form-label">
                                                Upload File
                                            </label>

                                            <a *ngIf="reportUpload" href="javascript:void(0)"
                                                class="text-decoration-none text-primary small fw-semibold d-inline-flex align-items-center"
                                                (click)="previewFile(reportUpload,'IdentityDetails2')">
                                                <i>View</i>
                                            </a>
                                        </div>
                                        <input class="form-control" type="file" id="deptUploadFile"
                                            (change)="onFileChange($event)" name="document"
                                            [(ngModel)]="DepUpload.DepartmentalRemarkDocument">
                                        <small class="form-text text-muted">
                                            type: pdf | Max size: 2 MB
                                        </small>

                                    </div>


                                    <!-- Download Buttons Section -->
                                    <div class="col-lg-6 mb-2"
                                        *ngIf="(!isShowVerRemark || !isShowArRemark) && isShowAuditor">
                                        <div class="">
                                            <label class="form-label mb-2">Download Documents</label>
                                            <div class="d-flex align-items-center gap-2">

                                                <button type="button" class="btn btn-success btn-sm"
                                                    (click)="downloadDocument(auditorUploadedDocument)"
                                                    title="Download Auditor Report">
                                                    <i class="bi bi-download me-1"></i> Auditor
                                                </button>

                                            </div>
                                        </div>
                                    </div>

                                    <!-- Remarks Section -->
                                    <div class="col-lg-12 mb-2">
                                        <div class="mb-3"
                                            *ngIf="(!isShowVerRemark || !isShowArRemark) && isShowAuditor">
                                            <label class="form-label">Auditor Remark</label>
                                            <textarea class="form-control" rows="3" disabled
                                                [ngModel]="auditStatus?.sRemark || ''" name="auditorRemark"></textarea>
                                        </div>

                                        <div class="mb-3" *ngIf="isShowVerRemark">
                                            <label class="form-label">Write Comment here<span
                                                    class="text-danger">*</span></label>

                                            <textarea class="form-control" rows="3" placeholder="Enter Comment Here..."
                                                [(ngModel)]="DepUpload.sDepartmentalRemark" name="deptRemark"
                                                required></textarea>
                                        </div>

                                        <div class="mb-3" *ngIf="isShowArRemark">
                                            <label class="form-label">Write Comment here <span
                                                    class="text-danger">*</span></label>
                                            <textarea class="form-control" rows="3" placeholder="Enter Comment Here..."
                                                [(ngModel)]="ARnewUpload.sDepartmentalRemark" name="arRemark"
                                                required></textarea>
                                        </div>

                                    </div>
                                  


                                </div>
                                  <div class="modal fade" id="IdentityDetails">
                                        <div class="modal-dialog modal-xl modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title">Preview File</h5>
                                                    <button type="button" class="btn-close"
                                                        data-bs-dismiss="modal"></button>
                                                </div>
                                                <div class="modal-body text-center">


                                                    <iframe [src]="base64Pdf"
                                                        style="width:100%; height:70vh; border:none;">
                                                    </iframe>


                                                    <img *ngIf="!arUpload?.includes('pdf')" [src]="arUpload"
                                                        style="max-width:100%; max-height:70vh;" />

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal fade" id="IdentityDetails2">
                                        <div class="modal-dialog modal-xl modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title">Preview File</h5>
                                                    <button type="button" class="btn-close"
                                                        data-bs-dismiss="modal"></button>
                                                </div>
                                                <div class="modal-body text-center">


                                                    <iframe [src]="base64Pdf"
                                                        style="width:100%; height:70vh; border:none;">
                                                    </iframe>


                                                    <img *ngIf="!reportUpload?.includes('pdf')" [src]="reportUpload"
                                                        style="max-width:100%; max-height:70vh;" />

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                <!-- Action Button -->
                                <!-- <div class="text-end">
                                <button type="submit" class="btn btn-primary mt-2" [disabled]="deptRemarkForm.invalid"
                                    *ngIf="isShowupdateButton">
                                    Update Status
                                </button>
                            </div> -->
                                <div class="text-end">
                                    <button type="submit" class="btn btn-primary mt-2"
                                        [disabled]="deptRemarkForm.invalid || isStatusUpdating"
                                        *ngIf="isShowupdateButton">
                                        <span *ngIf="!isStatusUpdating">Update Status</span>
                                        <span *ngIf="isStatusUpdating">
                                            <span class="spinner-border spinner-border-sm me-1" role="status"
                                                aria-hidden="true"></span>
                                            loading...
                                        </span>
                                    </button>
                                </div>

                            </form>
                            <br />
                            <h5 class="election-title">Audit Remarks (Scrutiny & AR)</h5>

                            <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                [rows]="rows" [columns]="cols" [columnMode]="'force'" [headerHeight]="50"
                                [footerHeight]="50" rowHeight="auto" [externalPaging]="true" [count]="page.totalRecords"
                                [offset]="page.pageNumber" [limit]="page.pageSize" [virtualization]="false"
                                [scrollbarV]="false" [scrollbarH]="true" [loadingIndicator]="loading">
                                <ngx-datatable-column name="#" [sortable]="false">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        <span>{{ rowIndex + 1 }}</span>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column *ngFor="let column of cols" [name]="column.name"
                                    [prop]="column.prop">
                                    <ng-template ngx-datatable-cell-template let-value="value">
                                        <span *ngIf="column.prop === 'date'">
                                            {{ value ? (value | date: 'dd-MM-yyyy') : '-' }}
                                        </span>

                                        <span *ngIf="column.prop === 'document'">
                                            <button *ngIf="value && value !== '-'" type="button"
                                                class="btn btn-success btn-sm" (click)="downloadDocument(value)"
                                                title="Download Report">
                                                <i class="bi bi-download me-1"></i> Report
                                            </button>
                                            <span *ngIf="!value || value === '-'">-</span>
                                        </span>



                                        <span *ngIf="column.prop !== 'date' && column.prop !== 'document'">
                                            {{ value || '-' }}
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>
                            </ngx-datatable>

                        </div>




                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<!-- Status Modal -->
<div class="modal fade" id="AuditorStatus" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="AuditorStatusLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="AuditorStatusLabel">
                    <i class="bi bi-clock-history me-2"></i> Audit Status
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body p-3">

                <div class="card border shadow-sm">
                    <div class="card-body p-3">
                        <div class="step-progressbar">

                            <div class="v-progress" style="max-height: 300px; overflow-y: auto;">
                                <ul class="list-group list-group-flush">
                                    <li *ngFor="let process of filteredStatus" class="list-group-item">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong class="text-dark">{{ process.roleName }}</strong>
                                                <div class="text-muted small mt-1">
                                                    <strong class="text-danger">Action:</strong> {{ process.remarks }}
                                                </div>
                                            </div>
                                            <div class="text-end">
                                                <span class="badge bg-light text-dark border">
                                                    <strong class="text-danger">Date:</strong>
                                                    {{ process.dCreateDate | date:'dd/MM/yyyy' }}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<!-- Status Modal -->
<div class="modal fade" id="AuditRemark" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="AuditRemarkLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="AuditRemarkLabel">
                    <i class="bi bi-clock-history me-2"></i> Audit Remark
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body p-3">

                <div class="card border shadow-sm">
                    <div class="card-body p-3">
                        <div class="step-progressbar">

                            <div class="v-progress" style="max-height: 300px; overflow-y: auto;">
                                <ul class="list-group list-group-flush">
                                    <li *ngFor="let process of filteredStatus" class="list-group-item">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong class="text-dark">{{ process.roleName }}</strong>
                                                <div class="text-muted small mt-1">
                                                    <strong class="text-danger">Action:</strong> {{ process.remarks }}
                                                </div>
                                            </div>
                                            <div class="text-end">
                                                <span class="badge bg-light text-dark border">
                                                    <strong class="text-danger">Date:</strong>
                                                    {{ process.dCreateDate | date:'dd/MM/yyyy' }}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>